export enum SprintsViewMode {
	ALL= 'ALL',
	ACTIVE = 'ACTIVE',
	UPCOMING = 'UPCOMING',
	COMPLETED = 'COMPLETED'
}
